import { api } from "@shared/lib/api";
import { BackednResponse } from "@shared/lib/types";
import {
  IBrandPermissions,
  IGetPermissionGroups,
  PermissionGroup,
} from "@shared/lib/types/permissions";

export class PoliciesService {
  public static async searchPermissionGroups(payload: {
    filterBy: {
      brandOrganisationId: string;
    };
    limit: number;
    pageNo: number;
    searchQuery?: string;
  }) {
    const url = `brand-organisation/permission-groups/search`;
    return (await api
      .post(url, {
        json: payload,
      })
      .json()) as BackednResponse<IGetPermissionGroups>;
  }

  public static async createPermissionGroup(payload: {
    brandOrganisationId: string;
    name: string;
    permissions: string[];
    description?: string;
  }) {
    const url = `brand-organisation/permission-groups`;
    return (await api
      .put(url, {
        json: payload,
      })
      .json()) as BackednResponse<PermissionGroup>;
  }

  public static async editPermissionGroup(payload: {
    brandOrganisationId: string;
    name: string;
    permissions: string[];
    description?: string;
    permissionGroupId: string;
  }) {
    const url = `brand-organisation/permission-groups`;
    return (await api
      .post(url, {
        json: payload,
      })
      .json()) as BackednResponse<PermissionGroup>;
  }

  public static async getBrandPermissions() {
    const url = `permissions/brand`;
    return (await api.get(url).json()) as BackednResponse<IBrandPermissions>;
  }
}
